<template>
   <div class="row">
       <div class="col-12">
           <div class="table-responsive">
               <div class="table-wrapper">
                 <table class="table table-hover">
                     <thead>
                     <tr>
                         <th width="5%">№</th>
                         <th width="10%">Бино номи</th>
                         <th width="10%" class="text-center">Бино хажми (м3)</th>
                         <th width="15%" class="text-center">Қурилиш ости майдони (м2)</th>
                         <th width="15%" class="text-right">Бахоланган қиймати</th>
                         <th width="100%" class="text-center">ЖАРАЁН</th>
                     </tr>
                     </thead>
                     <tbody>
                     <tr>
                         <td>{{building.id}}</td>
                         <td>{{building.name}}</td>
                         <td class="text-center">{{building.volume}} м3</td>
                         <td class="text-center">{{building.area}} м2</td>
                         <td class="text-right">
                      <span v-if="building.calculated && building.calculated.price && building.calculated.price.expense">
                          {{building.calculated.price.expense | currency('', 2, { thousandsSeparator: ' ' })}} сум
                      </span>
                         </td>
                         <td class="td-actions text-center">
                             <button class="all-btn ml-3" @click="showCalculatedTable">
                                 Жадвал
                             </button>
                         </td>
                     </tr>
                     </tbody>
                 </table>
               </div>
           </div>
       </div>
       <RealEstateBuildingCalculatedView />
   </div>
</template>

<script>
    import {parseDate} from '@/shared/utils';
    import RealEstateBuildingCalculatedView from '@/views/real-estate/RealEstateBuildingCalculatedView';
    export default {
        name: "ActBuildingCalculatedView",
        components: {
            RealEstateBuildingCalculatedView
        },
        props: {
            data: Object,
            initData: Object
        },
        data() {
            return {
                building: {},
                realEstate: {},
                coefficient: {
                    index: [],
                    earthquake: [],
                    regional: [],
                    capital: [],
                    height: [],
                    volume: [],
                    business: []
                },
                formDefault: {
                    fields: ["name", "made_year", "floors", "area", "height", "volume", "earthquake_point", "business_coefficient",
                        "foundation", "wall", "house_top", "house_cover", "floor_type", "window_and_doors", "half_timbers", "columns_and_pillars"]
                },
                cadastreBuildingFields: [],
                cadastreBuildingFieldReferences: {},
                cadastreBuildingDepreciationFields: []
            }
        },
        computed: {
            checkedDepreciationFields() {
                if (this.building && this.building.cadastreBuilding && this.building.cadastreBuilding.id && this.building.cadastreBuilding.id > 0) {
                    if (this.building.cadastreBuilding.data
                        && this.building.cadastreBuilding.data.depreciation
                        && this.building.cadastreBuilding.data.depreciation.codes
                        && this.building.cadastreBuilding.data.depreciation.codes.length > 0) {
                        return this.cadastreBuildingDepreciationFields.filter((field) => {
                            return this.building.cadastreBuilding.data.depreciation.codes.includes(field.code);
                        });
                    } else {
                        return [];
                    }
                } else {
                    return [];
                }
            },
            checkedCustomFields() {
                return this.cadastreBuildingFields.filter((field) => {
                    return !field.system && this.hasField(field.code);
                });
            },
            calculatedAll() {
                //CADASTRE BUILDING CATEGORY CALCULATION
                let cbCategoryCode = '';
                let cbCategoryVol = null;
                let cbCategoryVolDefault = null;
                const cb = this.building.cadastreBuilding;
                const system_number_fields = ['made_year', 'floors', 'area', 'height', 'height_inner', 'volume'];
                const system_number_fields_code = ['madeYear', 'floors', 'area', 'height', 'heightInner', 'volume'];
                if (cb) {
                    if (cb.hasOwnProperty('chooseCategory') && cb.chooseCategory) {
                        cbCategoryCode = this.building.cadastreBuildingCategory;
                    } else if (cb.data && cb.data.category && cb.data.category.settings) {
                        Object.keys(cb.data.category.settings).forEach((category_code) => {
                            const category_settings = cb.data.category.settings[category_code];
                            const category_criteria = category_settings.criteria;
                            let category_volume = null;
                            if (category_criteria && category_criteria.length > 0) {
                                let has_not_matched_items = false;
                                category_criteria.forEach((criteria) => {
                                    const field_code = criteria.field;
                                    const field_index = system_number_fields.indexOf(field_code);
                                    if (field_index >= 0) {
                                        const value = this.building[system_number_fields_code[field_index]];
                                        if ((criteria.valueMin && value < criteria.valueMin) || (criteria.valueMax && value > criteria.valueMax)) {
                                            has_not_matched_items = true;
                                        }
                                        if (field_code === 'volume') {
                                            category_volume = criteria.valueMax;
                                            if (category_code === 'a') {
                                                cbCategoryVolDefault = criteria.valueMax;
                                            }
                                        }
                                    } else {
                                        const custom_fields = this.cadastreBuildingFields.filter((field) => field.code === field_code);
                                        if (custom_fields && custom_fields.length > 0) {
                                            const custom_field = custom_fields[0];
                                            if (this.building.data && this.building.data.values && this.building.data.values.hasOwnProperty(custom_field.code)) {
                                                const custom_field_data = this.building.data.values[custom_field.code];
                                                if (custom_field.type === 'INTEGER' || custom_field.type === 'DECIMAL') {
                                                    const value = custom_field_data;
                                                    if ((criteria.valueMin && value < criteria.valueMin) || (criteria.valueMax && value > criteria.valueMax)) {
                                                        has_not_matched_items = true;
                                                    }
                                                } else if (custom_field.type === 'COMBOBOX' || custom_field.type === 'LISTBOX') {
                                                    if (custom_field_data && custom_field_data.code) {
                                                        if (custom_field_data.code !== criteria.value) {
                                                            has_not_matched_items = true;
                                                        }
                                                    }
                                                } else {
                                                    if (custom_field_data) {
                                                        if (custom_field_data !== criteria.value) {
                                                            has_not_matched_items = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                });
                                if (!has_not_matched_items) {
                                    cbCategoryCode = category_code;
                                    cbCategoryVol = category_volume;
                                }
                            }
                        });
                    }
                }

                if (cbCategoryCode === '') {
                    cbCategoryCode = 'a';
                    cbCategoryVol = cbCategoryVolDefault;
                }

                //DEPRECIATION TOTAL CALCULATIONS
                let totalDepreciationWeight = 0;
                let totalDepreciationChange = 0;
                let totalDepreciationNext = 0;
                let totalDepreciationCalculated = 0;

                // console.log('checked_depreciation_fields_count:' + this.checkedDepreciationFields.length);
                if (this.checkedDepreciationFields.length > 0) {
                    const vm = this;
                    this.checkedDepreciationFields.forEach((field) => {
                        let weight = 0;
                        if (vm.building.cadastreBuilding && vm.building.cadastreBuilding.data && vm.building.cadastreBuilding.data.depreciation
                            && vm.building.cadastreBuilding.data.depreciation.weights
                            && vm.building.cadastreBuilding.data.depreciation.weights.hasOwnProperty(field.code)
                            && vm.building.cadastreBuilding.data.depreciation.weights[field.code]
                            && vm.building.cadastreBuilding.data.depreciation.weights[field.code].hasOwnProperty(cbCategoryCode)
                            && vm.building.cadastreBuilding.data.depreciation.weights[field.code][cbCategoryCode]) {
                            weight = vm.building.cadastreBuilding.data.depreciation.weights[field.code][cbCategoryCode];
                            // console.log('weight:' + field.name + ':' + weight);
                        }/* else {
                            console.log('weight_not_found:' + field.name);
                        }*/
                        field.weight = ((weight && weight > 0) ? weight : 0);
                        field.change = ((field.change && field.change > 0) ? field.change : 0);
                        field.next = (weight >= field.change ? (weight - field.change) : 0);

                        const dilapidation = this.building.dilapidationValueByExpert;
                        if (dilapidation && dilapidation > 0){
                            field.erosion = dilapidation;
                        } else {
                            field.erosion = 0;
                        }

                        field.calculated = (field.next * field.erosion) / 100;

                        totalDepreciationWeight += ((field.weight && field.weight > 0) ? field.weight : 0);
                        totalDepreciationChange += ((field.change && field.change > 0) ? field.change : 0);
                        totalDepreciationNext += ((field.next && field.next > 0) ? field.next : 0);
                        totalDepreciationCalculated += ((field.calculated && field.calculated > 0) ? field.calculated : 0);
                    });
                } else {
                    totalDepreciationNext = 100;
                    totalDepreciationCalculated = (this.building.depreciationPercent ? this.building.depreciationPercent : 0);
                }

                // recovery price calculation
                let recoveryPriceUnit = 'volume';
                let recoveryPriceUnitValue = null;
                let recoveryPricePerUnit = 0;
                // const categoryCode = this.building.cadastreBuildingCategory;
                if (cb && cb.data) {
                    if (cb.data.recoveryFieldCode && cb.data.recoveryFieldCode.length > 0) {
                        recoveryPriceUnit = cb.data.recoveryFieldCode;
                    }
                    if (cb.data.category && cb.data.category.settings
                        && cb.data.category.settings.hasOwnProperty(cbCategoryCode)
                        && cb.data.category.settings[cbCategoryCode] && cb.data.category.settings[cbCategoryCode].recoveryPrice) {
                        recoveryPricePerUnit = cb.data.category.settings[cbCategoryCode].recoveryPrice;
                    }
                    // if (cb.data.additionalValues && cb.data.additionalValues.length > 0) {
                    //     const addValuesChecked = cb.data.additionalValues.filter((value) => {
                    //         return this.building.data.additionalValues.indexOf(value.code) >= 0;
                    //     });
                    //     if (addValuesChecked.length > 0) {
                    //         addValuesChecked.forEach((value) => {
                    //             if (value.values && value.values.hasOwnProperty(cbCategoryCode) && value.values[cbCategoryCode] && value.values[cbCategoryCode] > 0) {
                    //                 recoveryPricePerUnit += value.values[cbCategoryCode];
                    //             }
                    //         });
                    //     }
                    // }
                }
                if (recoveryPriceUnit === 'volume') {
                    recoveryPriceUnitValue = this.building.volume;
                } else if (recoveryPriceUnit === 'height') {
                    recoveryPriceUnitValue = this.building.height;
                } else if (recoveryPriceUnit === 'height_inner') {
                    recoveryPriceUnitValue = this.building.heightInner;
                } else if (recoveryPriceUnit === 'floors') {
                    recoveryPriceUnitValue = this.building.floors;
                } else if (recoveryPriceUnit === 'area') {
                    recoveryPriceUnitValue = this.building.area;
                } else if (recoveryPriceUnit === 'earthquake_point') {
                    recoveryPriceUnitValue = this.building.earthquakePoint;
                } else if (recoveryPriceUnit === 'business_coefficient') {
                    recoveryPriceUnitValue = this.building.businessCoefficient;
                } else {
                    const custom_fields = this.cadastreBuildingFields.filter((field) => field.code === recoveryPriceUnit);
                    if (custom_fields && custom_fields.length > 0) {
                        const custom_field = custom_fields[0];
                        if ((custom_field.type === 'INTEGER' || custom_field.type === 'DECIMAL') && custom_field.value && custom_field.value > 0) {
                            recoveryPriceUnitValue = custom_field.value;
                        } else if (custom_field.type === 'LISTBOX' && custom_field.value && custom_field.value.length > 0) {
                            recoveryPriceUnitValue = parseFloat(custom_field.value);
                        } else if (custom_field.type === 'COMBOBOX' && custom_field.selected && custom_field.selected.code && custom_field.selected.code.length > 0) {
                            recoveryPriceUnitValue = parseFloat(custom_field.selected.code);
                        }
                    }
                }

                // constructive change value calculation
                let constructiveChange = (totalDepreciationNext * recoveryPricePerUnit) / 100;

                if (cb && cb.data) {
                    if (cb.data.additionalValues && cb.data.additionalValues.length > 0) {
                        const addValuesChecked = cb.data.additionalValues.filter((value) => {
                            return this.building.data.additionalValues.indexOf(value.code) >= 0;
                        });
                        if (addValuesChecked.length > 0) {
                            addValuesChecked.forEach((value) => {
                                if (value.values && value.values.hasOwnProperty(cbCategoryCode) && value.values[cbCategoryCode] && value.values[cbCategoryCode] > 0) {
                                    constructiveChange += value.values[cbCategoryCode];
                                }
                            });
                        }
                    }
                }

                // recover price 1991 calculation
                let recoveryPrice1991 = 0;
                if (recoveryPriceUnitValue) {
                    recoveryPrice1991 = constructiveChange * recoveryPriceUnitValue;
                }

                // BUILDING PRICE CALCULATION START
                // building price calculation before coefficients
                let priceBuilding = recoveryPrice1991;
                if (this.coefficient && this.coefficient.index && this.coefficient.index.length > 0) {
                    this.coefficient.index.forEach((index) => {
                        if (index.value) {
                            priceBuilding = priceBuilding * index.value;
                        }
                    });
                }
                //building price calculation - earthquake coefficient
                let book = 1;
                if (this.building.cadastreBuilding && this.building.cadastreBuilding.cadastreSection && this.building.cadastreBuilding.cadastreSection.book) {
                    book = this.building.cadastreBuilding.cadastreSection.book;
                }

                let coefficientEarthQuake = 1;

                if (this.building.cadastreBuilding && this.building.cadastreBuilding.buildingType && this.building.earthquakePoint && !this.building.cadastreBuilding.earthquakePointEnabled) {
                    const items = this.coefficient.earthquake.filter((item) => {
                        return item.type === this.building.cadastreBuilding.buildingType
                            && item.category === this.building.cadastreBuilding.buildingCategory
                            && item.points === this.building.earthquakePoint && item.book === book;
                    });
                    if (items.length > 0) {
                        coefficientEarthQuake = items[0].value;
                    }
                }
                priceBuilding = priceBuilding * coefficientEarthQuake;

                //building price calculation - regional coefficient
                let coefficientRegional = 1;
                if (this.building && this.building.cadastreBuilding && this.building.cadastreBuilding
                    && this.building.cadastreBuilding.section && this.building.cadastreBuilding.section.book
                    && this.realEstate.province && this.realEstate.province.id) {
                    const regional_items = this.coefficient.regional.filter((item) => {
                        return item.book === this.building.cadastreBuilding.section.book && item.provinceId === this.realEstate.province.id && item.book === book;
                    });
                    if (regional_items.length >= 1) {
                        coefficientRegional = regional_items[0].value;
                    }
                }
                priceBuilding = priceBuilding * coefficientRegional;

                //building price calculation - capital coefficient
                let coefficientCapital = 1;
                if (this.building && this.building.cadastreBuilding) {
                    let capitals_map = {
                        "I": {value: 1, weight : 0},
                        "II": {value: 2, weight : 0},
                        "III": {value: 3, weight : 0},
                        "IV": {value: 4, weight : 0},
                        "V": {value: 5, weight : 0}
                    };
                    let book_capital_group;
                    const cBuilding = this.building.cadastreBuilding;
                    const cBuildingCategory = this.building.cadastreBuildingCategory;
                    if (cBuilding && cBuilding.data) {
                        let capitalGroupCode;
                        if (cBuilding.data.capitalGroupByCategory) {
                            if (cBuildingCategory && cBuildingCategory.length > 0
                                && cBuilding.data.category && cBuilding.data.category.settings
                                && cBuilding.data.category.settings.hasOwnProperty(cBuildingCategory)) {
                                const categorySettings = cBuilding.data.category.settings[cBuildingCategory];
                                if (categorySettings && categorySettings.hasOwnProperty('capitalGroup')) {
                                    capitalGroupCode = categorySettings['capitalGroup'];
                                }
                            }
                        } else {
                            if (cBuilding.data.capitalGroup && cBuilding.data.capitalGroup.length > 0) {
                                capitalGroupCode = cBuilding.data.capitalGroup;
                            }
                        }
                        if (capitalGroupCode && capitalGroupCode.length > 0 && capitals_map.hasOwnProperty(capitalGroupCode)) {
                            book_capital_group = capitals_map[capitalGroupCode].value;
                        }
                    }

                    if (book_capital_group && book_capital_group > 0) {
                        let calculated_max_weight = 0;
                        let calculated_capital_group;

                        let capitals_key = 'capitals';
                        if (this.building.cadastreBuilding && this.building.cadastreBuilding.buildingCategory
                            && this.building.cadastreBuilding.buildingCategory.length === 'Residential') {
                            capitals_key = 'capitals_residential';
                        }

                        this.cadastreBuildingFields.forEach((field) => {
                            if (field.data && field.data.values && field.data.values.hasOwnProperty('capital_weight')) {
                                const weight = field.data.values['capital_weight'];
                                if (field.selected && field.selected.data && field.selected.data.values && field.selected.data.values.hasOwnProperty(capitals_key)) {
                                    const capitals = field.selected.data.values[capitals_key];
                                    if (capitals && capitals.length > 0) {
                                        capitals.forEach((capital) => {
                                            if (capitals_map.hasOwnProperty(capital)) {
                                                capitals_map[capital].weight += weight;
                                                if (capitals_map[capital].weight > calculated_max_weight) {
                                                    calculated_max_weight = capitals_map[capital].weight;
                                                    calculated_capital_group = capitals_map[capital].value
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                        });
                        if (!calculated_capital_group) {
                            calculated_capital_group = book_capital_group;
                        }
                        if (calculated_capital_group) {
                            let building_category = 'Notorious';
                            if (this.building.cadastreBuilding && this.building.cadastreBuilding.buildingCategory
                                && this.building.cadastreBuilding.buildingCategory.length > 0) {
                                building_category = this.building.cadastreBuilding.buildingCategory;
                            }
                            const capital_items = this.coefficient.capital.filter((item) => {
                                return item.bookGroup === book_capital_group
                                    && item.buildingGroup === calculated_capital_group
                                    && item.category === building_category;
                            });
                            if (capital_items.length > 0) {
                                coefficientCapital = capital_items[0].value;
                            }
                        }
                    }
                }
                priceBuilding = priceBuilding * coefficientCapital;

                //building price calculation - height coefficient
                let coefficientHeight = 1;
                if (this.building.cadastreBuilding && this.building.cadastreBuilding.buildingType
                    && this.building.cadastreBuilding.buildingType === 'Civil'
                    && this.building.heightInner && this.building.heightInner > 0) {
                    let lastAcceptableHeight;
                    this.coefficient.height.forEach((height) => {
                        if (height.height <= this.building.heightInner) {
                            lastAcceptableHeight = height;
                        } else {
                            coefficientHeight = 1.06
                        }
                    });
                    if (lastAcceptableHeight) {
                        coefficientHeight = lastAcceptableHeight.value;
                    }
                }
                priceBuilding = priceBuilding * coefficientHeight;

                //building price calculation - volume coefficient
                let coefficientVolume = 1;
                if (this.building.cadastreBuildingCategoryVol && this.building.cadastreBuildingCategoryVol >= 0 && this.building.volume && this.building.volume >= 0) {
                    this.coefficient.volume.forEach((bookVol) => {
                        if (this.building.cadastreBuildingCategoryVol >= bookVol.min && this.building.cadastreBuildingCategoryVol <= bookVol.max) {
                            if (bookVol.items && bookVol.items.length > 0) {
                                bookVol.items.forEach((evlVol) => {
                                    if (this.building.volume >= evlVol.min && this.building.volume <= evlVol.max) {
                                        coefficientVolume = evlVol.coefficient;
                                    }
                                });
                            }
                        }
                    });
                }
                priceBuilding = priceBuilding * coefficientVolume;

                // //building price calculation - business coefficient
                priceBuilding = priceBuilding * this.building.businessCoefficient;
                // BUILDING PRICE CALCULATION END

                //DEPRECIATION CALCULATION START
                let calculatedDepreciationPercent = 0;
                let calculatedDepreciationTotal = 0;
                if (totalDepreciationNext && totalDepreciationNext > 0) {
                    // calculatedDepreciationPercent = totalDepreciationCalculated * 100 / totalDepreciationNext;
                    calculatedDepreciationPercent = totalDepreciationCalculated;
                    calculatedDepreciationTotal = priceBuilding * calculatedDepreciationPercent / 100;
                }
                //DEPRECIATION CALCULATION END

                // //PRICE CALCULATION - EXPENSE METHOD
                const priceExpense = priceBuilding - calculatedDepreciationTotal;

                return {
                    modelLastChangeTime: this.modelLastChangeTime,
                    category: {
                        code: cbCategoryCode,
                        volume: cbCategoryVol
                    },
                    calculated: {
                        constructive: {
                            change: constructiveChange
                        },
                        recovery: {
                            unit: 'volume',
                            pricePerUnit: recoveryPricePerUnit,
                            price1991: recoveryPrice1991
                        },
                        coefficient: {
                            earthquake: coefficientEarthQuake,
                            regional: coefficientRegional,
                            capital: coefficientCapital,
                            height: coefficientHeight,
                            volume: coefficientVolume,
                            business: this.building.businessCoefficient
                        },
                        depreciation: {
                            weight: totalDepreciationWeight,
                            change: totalDepreciationChange,
                            next: totalDepreciationNext,
                            calculated: totalDepreciationCalculated,
                            percent: calculatedDepreciationPercent,
                            total: calculatedDepreciationTotal
                        },
                        price: {
                            building: priceBuilding,
                            expense: priceExpense,
                            income: 0,
                            comparative: 0
                        }
                    }
                };
            }
        },
        methods: {
            init() {
                const vm = this;
                const formData = this.data;
                vm.realEstate = vm.initData.realEstate;
                vm.coefficient = vm.initData.coefficient;
                vm.cadastreBuildingFields = vm.initData.fields;
                vm.cadastreBuildingFieldReferences = vm.initData.references;
                vm.cadastreBuildingDepreciationFields = vm.initData.depreciation.map((field) => {
                    field.weight = 0;
                    field.change = 0;
                    field.erosion = 0;
                    return field;
                });

                if (formData && formData.settings && formData.settings.indexes && formData.settings.indexes.length > 0) {
                    vm.coefficient.index = formData.settings.indexes;
                }

                if (formData.data && formData.data.values) {
                    vm.cadastreBuildingFields.forEach((field) => {
                        if (field.code && !field.system && formData.data.values.hasOwnProperty(field.code)) {
                            const fieldValue = formData.data.values[field.code];
                            if (fieldValue) {
                                if (field.type === 'COMBOBOX' || field.type === 'LISTBOX') {
                                    if (fieldValue.id && fieldValue.id > 0) {
                                        field.value = fieldValue.id;
                                        field.selected = vm.getReferenceById(field.reference.code, fieldValue.id);
                                    }
                                } else if (field.type === 'MULTISELECT') {
                                    if (fieldValue) {
                                        field.selected = [];
                                        if (fieldValue.length > 0) {
                                            fieldValue.forEach((ref) => {
                                                field.selected.push(ref.id);
                                            });
                                        } else if (fieldValue.hasOwnProperty('id') && fieldValue.id && fieldValue.id > 0) {
                                            field.selected.push(fieldValue.id);
                                        }
                                        field.value = field.selected;
                                    }
                                } else if (field.type === 'DATE_PICKER') {
                                    if (fieldValue) {
                                        field.date = parseDate(fieldValue);
                                    }
                                } else {
                                    field.value = fieldValue;
                                }
                            }
                        }
                    });
                    if (formData.depreciations && formData.depreciations.length > 0) {
                        vm.cadastreBuildingDepreciationFields.forEach((field) => {
                            formData.depreciations.forEach((depreciation) => {
                                if (depreciation.field && depreciation.field.id && depreciation.field.id === field.id) {
                                    field.weight = depreciation.weight;
                                    field.change = depreciation.change;
                                    field.erosion = depreciation.erosion;
                                }
                            });
                        });
                    }
                }
                if (!formData.data) {
                    formData.data = {};
                }
                if (!formData.data.values) {
                    formData.data.values = {};
                }
                if (!formData.data.additionalValues) {
                    formData.data.additionalValues = [];
                }

                this.building = formData;
            },
            showCalculatedTable() {
                this.building.cadastreBuildingCategory = this.calculatedAll.category.code;
                this.building.cadastreBuildingCategoryVol = this.calculatedAll.category.volume;
                this.building.calculated = this.calculatedAll.calculated;

                const fields = this.checkedCustomFields;
                fields.forEach((field) => {
                    if (field.type && field.type === 'MULTISELECT') {
                        if (field.value && field.value.length > 0) {
                            let valueAsLabel = '';
                            field.value.forEach((option_id) => {
                                const optionSelected = this.getReferenceById(field.reference.code, option_id);
                                if (optionSelected && optionSelected.name && optionSelected.name.length > 0) {
                                    if (valueAsLabel.length > 0) {
                                        valueAsLabel += ', ';
                                    }
                                    valueAsLabel += optionSelected.name;
                                }
                            });
                            field.valueAsLabel = valueAsLabel;
                        }
                    }
                });

                const data = {
                    realEstate: this.realEstate,
                    building: this.building,
                    coefficient: this.coefficient,
                    fields: fields,
                    depreciationFields: this.checkedDepreciationFields
                };
                this.$eventBus.$emit('showRealEstateBuildingCalculatedTable', data);
            },
            hasField(code) {
                if (this.building && this.building.cadastreBuilding && this.building.cadastreBuilding.id && this.building.cadastreBuilding.id > 0) {
                    if (this.building.cadastreBuilding.data && this.building.cadastreBuilding.data.fields && this.building.cadastreBuilding.data.fields.length > 0) {
                        return this.building.cadastreBuilding.data.fields.includes(code);
                    } else {
                        return false;
                    }
                } else {
                    return this.formDefault.fields.includes(code);
                }
            },
            getReferenceById(code, id) {
                if (this.cadastreBuildingFieldReferences.hasOwnProperty(code)) {
                    const fieldReferences = this.cadastreBuildingFieldReferences[code];
                    const references = fieldReferences.filter((ref) => {
                        return ref.id === id
                    });
                    return references.length > 0 ? references[0] : null;
                } else {
                    return null;
                }
            },
        },
        watch: {
            data() {
               this.init();
            }
        }
    }
</script>

<style scoped>

</style>